import * as React from "react";

const TableCell = React.forwardRef(({ className, ...props }, ref) => (
  <td ref={ref} className={className} {...props} />
));
TableCell.displayName = "TableCell";

export { TableCell };
